import { CurrencyType } from '../types'

// Gets Stripes Cut
export const calculateStripeFee = (price): number => {
  if (price && price > 0) {
    return price * 0.029 + 0.3 // 30 cents
  }
  return undefined
}

export const calculateXenditFee = (price): number => {
  if (price && price > 0) {
    console.log(price)
    return price * 0.05 // 5% transaction fee
  }
  return undefined
}

// returns money amount after feeds are removed
export const calculateApplicationFee = (price, currency = 'usd') => {
  let fee = null
  if (currency === CurrencyType.IDR) {
    fee = calculateXenditFee(price)
  } else if (currency === CurrencyType.USD) {
    fee = calculateStripeFee(price)
  }
  if (price && price > 0 && fee) {
    return price - (price * 5) / 100 - fee
  }
  return undefined
}

// Formats money values
export function toDollarString(num?: number) {
  if (num) {
    return `$${num.toFixed(2)}`
  } else {
    return `$0.00`
  }
}
